module.exports = __webpack_public_path__ + "static/media/yunjiadajianshan_web.97fc29eb.png";